<template lang="pug">
    .component-statistics-card.statistics-card-4
            .row
                .columns.small-6.large-3
                    .inner-content.card
                       slot(name="n1")
                .columns.small-6.large-3
                    .inner-content.card
                        slot(name="n2")
                .columns.small-6.large-3
                    .inner-content.card
                        slot(name="n3")
                .columns.small-6.large-3
                    .inner-content.card
                        slot(name="n4")
</template>
<script type="text/babel">
    export default{
        name: "StatisticsCard4",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        computed: {}
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// StatisticsCard4.vue?7f0e7aae